import { render, staticRenderFns } from "./sgzd.vue?vue&type=template&id=58b13474&scoped=true&"
import script from "./sgzd.vue?vue&type=script&lang=js&"
export * from "./sgzd.vue?vue&type=script&lang=js&"
import style0 from "./sgzd.vue?vue&type=style&index=0&id=58b13474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b13474",
  null
  
)

export default component.exports